import {
  BarChart3,
  BriefcaseBusiness,
  CircleUserRound,
  FileCog,
  Files,
  Inbox,
  ShieldCheck,
  UserRoundCheck,
} from "lucide-react";

export const employerNavigationSections = [
  {
    key: "operating-system",
    label: "Employer Case OS",
    items: [
      {
        href: "/dashboard/employer",
        label: "Arbeitsraum",
        icon: BriefcaseBusiness,
        match: (location) => location.pathname === "/dashboard/employer",
      },
      {
        href: "/dashboard/employer/jobs",
        label: "Anzeigen",
        icon: FileCog,
        match: (location) => location.pathname === "/dashboard/employer/jobs" || location.pathname.startsWith("/dashboard/employer/jobs/"),
      },
      {
        href: "/dashboard/employer/candidates",
        label: "Kandidaten",
        icon: Inbox,
        match: (location) => location.pathname === "/dashboard/employer/candidates",
      },
      {
        href: "/dashboard/employer/documents",
        label: "Dokumente",
        icon: Files,
        match: (location) => location.pathname === "/dashboard/employer/documents",
      },
      {
        href: "/dashboard/employer/compliance",
        label: "Filing & Compliance",
        icon: ShieldCheck,
        match: (location) => location.pathname === "/dashboard/employer/compliance",
      },
      {
        href: "/dashboard/employer/integration",
        label: "Integration",
        icon: UserRoundCheck,
        match: (location) => location.pathname === "/dashboard/employer/integration",
      },
      {
        href: "/dashboard/employer/analytics",
        label: "Analytics",
        icon: BarChart3,
        match: (location) => location.pathname === "/dashboard/employer/analytics",
      },
      {
        href: "/dashboard/employer/profile",
        label: "Arbeitgeberprofil",
        icon: CircleUserRound,
        match: (location) => location.pathname === "/dashboard/employer/profile",
      },
    ],
  },
];

export function flattenEmployerNavigationSections(sections = employerNavigationSections) {
  return sections.flatMap((section) => section.items || []);
}
